
import React from "react";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Spinner } from "@/components/ui/spinner";

interface LoadingStateProps {
  message?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ 
  message = "Loading location information..." 
}) => (
  <Card className="w-full max-w-4xl mx-auto">
    <CardHeader>
      <h2 className="text-xl font-semibold text-center">{message}</h2>
    </CardHeader>
    <CardContent className="flex justify-center py-12">
      <Spinner size="lg" />
    </CardContent>
  </Card>
);

interface ErrorStateProps {
  message: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ message }) => (
  <Card className="w-full max-w-4xl mx-auto">
    <CardHeader>
      <h2 className="text-xl font-semibold text-center">Error loading location</h2>
    </CardHeader>
    <CardContent>
      <Alert>
        <AlertDescription>{message}</AlertDescription>
      </Alert>
    </CardContent>
  </Card>
);

export const NoLocationsState: React.FC = () => (
  <Card className="w-full max-w-4xl mx-auto">
    <CardHeader>
      <h2 className="text-xl font-semibold text-center">No locations found</h2>
    </CardHeader>
    <CardContent>
      <Alert>
        <AlertDescription>
          No locations were found for this organization. Please contact the administrator.
        </AlertDescription>
      </Alert>
    </CardContent>
  </Card>
);
